import { DotsThreeVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { Badge } from "@volca/ui/components/ui/badge";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { SimpleSidebarHeader } from "@volca/ui/components/ui/simple-sidebar";

interface ManualEditsSidebarHeaderProps {
  editCount: number;
  reviewCount: number;
  isRecalculating: boolean;
  canDiscardAll: boolean;
  onDiscardAll: () => void;
  onClose: () => void;
}

export const ManualEditsSidebarHeader = ({
  editCount,
  reviewCount,
  isRecalculating,
  canDiscardAll,
  onDiscardAll,
  onClose,
}: ManualEditsSidebarHeaderProps) => (
  <SimpleSidebarHeader
    title="Manual edits"
    description={
      editCount === 0
        ? "Nothing edited this pay period"
        : `${editCount} ${editCount === 1 ? "edit" : "edits"} on this pay period`
    }
    actions={
      <>
        {reviewCount > 0 ? (
          <Badge variant="secondary" color="warning" size="sm">
            {reviewCount} to review
          </Badge>
        ) : null}
        {isRecalculating ? (
          <Badge
            variant="secondary"
            color="information"
            size="sm"
            role="status"
            aria-live="polite"
          >
            Recalculating
          </Badge>
        ) : null}
        {canDiscardAll ? (
          <DropdownMenu>
            <DropdownMenuTrigger
              render={
                <Button
                  variant="ghost"
                  size="icon"
                  type="button"
                  aria-label="More actions"
                  className="ml-auto shrink-0 text-subtle"
                />
              }
            >
              <DotsThreeVerticalIcon />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-max">
              <DropdownMenuItem variant="destructive" onClick={onDiscardAll}>
                Discard all edits
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null}
      </>
    }
    onClose={onClose}
  />
);
